import { render, staticRenderFns } from "./AssessmentBase.vue?vue&type=template&id=90898248&"
import script from "./AssessmentBase.vue?vue&type=script&lang=js&"
export * from "./AssessmentBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports